// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__Gjf_s","title":"ClientCherryInfo_title__XAx8R","itemText":"ClientCherryInfo_itemText__3mSRN"};